import React from 'react';
import './TermsPage.scss';

const TermsPage: React.FC = () => {
  return (
    <div className="policy-page terms-page">
      <div className="policy-page__container">
        <h1 className="policy-page__title">Terms & Conditions</h1>
        <p className="policy-page__updated">Last updated: December 30, 2024</p>

        <div className="policy-page__intro">
          <p>
            Welcome to $HTROM (operated by $HTROM.LLC). By accessing our website or purchasing 
            from us, you agree to be bound by the following Terms & Conditions.
          </p>
        </div>

        <div className="policy-page__content">
          <section className="policy-page__section">
            <h2 className="policy-page__section-title">General Conditions</h2>
            <p>
              We reserve the right to refuse service to anyone for any reason at any time. 
              You agree not to reproduce, duplicate, copy, sell, resell, or exploit any 
              portion of the Service without express written permission.
            </p>
          </section>

          <section className="policy-page__section">
            <h2 className="policy-page__section-title">Products & Availability</h2>
            <p>
              All products are subject to availability. We reserve the right to limit 
              quantities, discontinue products, or modify product offerings at any time.
            </p>
            <p>
              We make reasonable efforts to accurately display product details, colors, 
              and images. Variations may occur due to lighting or screen displays.
            </p>
          </section>

          <section className="policy-page__section">
            <h2 className="policy-page__section-title">Sizing & Product Disclaimer</h2>
            <p>
              Sizing may vary slightly due to manufacturing tolerances. Customers are 
              responsible for reviewing size charts prior to purchasing.
            </p>
          </section>

          <section className="policy-page__section">
            <h2 className="policy-page__section-title">Pricing & Payments</h2>
            <p>
              All prices are listed in USD and are subject to change without notice.
              By completing a purchase, you represent that you are authorized to use 
              the selected payment method.
            </p>
          </section>

          <section className="policy-page__section">
            <h2 className="policy-page__section-title">Shipping & Delivery</h2>
            <p>
              Orders are processed within a reasonable timeframe. Delivery estimates 
              are not guaranteed. Once marked as delivered, we are not responsible for 
              lost, stolen, or misdelivered packages.
            </p>
          </section>

          <section className="policy-page__section">
            <h2 className="policy-page__section-title">Returns & Exchanges</h2>
            <p className="policy-page__highlight">All sales are final.</p>
            <p>
              We do not accept returns or exchanges unless an item arrives damaged or 
              defective. Claims must be submitted within 48 hours of delivery with 
              photographic evidence.
            </p>
          </section>

          <section className="policy-page__section">
            <h2 className="policy-page__section-title">Intellectual Property</h2>
            <p>
              All designs, logos, artwork, and content are the exclusive property of 
              $HTROM.LLC and are protected under applicable copyright and trademark laws.
            </p>
          </section>

          <section className="policy-page__section">
            <h2 className="policy-page__section-title">Limited Drops</h2>
            <p>
              Certain products may be released as limited drops and may not be restocked. 
              Availability is not guaranteed, and purchases are final.
            </p>
          </section>

          <section className="policy-page__section">
            <h2 className="policy-page__section-title">Governing Law</h2>
            <p>
              These Terms shall be governed by the laws of the State of Florida, 
              United States.
            </p>
          </section>

          <section className="policy-page__section">
            <h2 className="policy-page__section-title">Contact</h2>
            <p className="policy-page__contact">
              <a href="mailto:support@shtromstudio.com">support@shtromstudio.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
